/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitGetEntityAssetSingleAssetQueries
 */
export interface MonitGetEntityAssetSingleAssetQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityAssetSingleAssetQueries
     */
    process_id?: string;
}

/**
 * Check if a given object implements the MonitGetEntityAssetSingleAssetQueries interface.
 */
export function instanceOfMonitGetEntityAssetSingleAssetQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityAssetSingleAssetQueriesFromJSON(json: any): MonitGetEntityAssetSingleAssetQueries {
    return MonitGetEntityAssetSingleAssetQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityAssetSingleAssetQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityAssetSingleAssetQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
    };
}

export function MonitGetEntityAssetSingleAssetQueriesToJSON(value?: MonitGetEntityAssetSingleAssetQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
    };
}

